import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { ProgramAttachment } from '../types';
import { ProgramApi } from '../programApi';

const getUrl = async (programApi: ProgramApi, programId: string, attachment: ProgramAttachment) => {
  return attachment.thumbnail
    ? window.URL.createObjectURL(attachment.thumbnail)
    : (await programApi.generateProgramAttachmentUrl(programId, attachment.id, true)).url;
};

export const useAttachmentThumbnail = (programId: string, attachment: ProgramAttachment) => {
  const cacheManager = useQueryCacheManager();
  const { programApi } = useApi();

  return useQuery({
    queryKey: cacheManager.getProgramAttachmentThumbnailCacheName(programId, attachment.id),
    queryFn: async (): Promise<string> => getUrl(programApi, programId, attachment),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchInterval: 0,
  });
};
